// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UWfmE","question":"styles_question__qFqJa","description":"styles_description__1HiUm"};